export default "__VITE_ASSET__DsXOlOcf__"